<template>
  <div class="floating-bar" :style="floatingBarStyle">
    <div class="mx-auto w-full">
      <div class="">
        <div>
          <ul class="footer-links flex-row">
            <li
              v-if="can_show_menu"
              v-for="section in footerBarSections"
              :key="section.id"
              class="p-1 md:p-3 mx-0 lg:p-1"
            >
              <a
                href=""
                :class="footer_btn_class"
                @click="on_section_click($event, section.id)"
                v-html="section.name"
              ></a>
            </li>

            <li
              v-if="can_show_menu"
              v-for="(link, index) in footer_additional_links"
              :key="'footer_link_' + index"
              class="mx-0"
            >
              <template v-if="link.type == 'external_link'">
                <a
                  :href="link.href"
                  :class="footer_btn_class"
                  v-ga="
                    $ga.commands.trackExternalLink.bind(get_this, link.href)
                  "
                  target="_blank"
                  v-html="link.title"
                ></a>
              </template>
              <template v-if="link.type == 'submenu'">
                <a
                  href="#"
                  :class="footer_btn_class"
                  @click.prevent="on_footer_menu_click($event, index)"
                  target="_blank"
                  v-html="link.title"
                ></a>
                <ul :class="submenu_class">
                  <li v-for="(sublink, subindex) in link.menu">
                    <a
                      :href="sublink.href"
                      target="_blank"
                      :key="'submenu_' + index + '_' + subindex"
                      v-if="sublink.type == 'external_link'"
                      v-ga="
                        $ga.commands.trackExternalLink.bind(
                          get_this,
                          sublink.href
                        )
                      "
                      >{{ sublink.title }}</a
                    >
                    <a
                      href="#"
                      :key="'submenu_' + index + '_' + subindex"
                      @click="
                        on_footer_submenu_popup_click($event, index, subindex)
                      "
                      v-if="sublink.type == 'popup'"
                      >{{ sublink.title }}</a
                    >
                  </li>
                </ul>
              </template>
              <template v-if="link.type == 'popup'">
                <a
                  href="#"
                  :class="footer_btn_class"
                  @click="on_footer_popup_click($event, index)"
                  v-html="link.title"
                ></a>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "FloatingBar",
  props: ["barWidth", "barTop", "barFontSize"],
  data() {
    return {
      submenu_extra_class: ""
    };
  },
  computed: {
    ...mapState([
      "app_state",
      "page_state",
      "current_section",
      "footer_additional_links",
      "sections",
      "sections_content",
      "site_config"
    ]),
    ...mapGetters(["footerBarSections", "sectionContent", "eventTag"]),
    floatingBarStyle() {
      return {
        width: this.barWidth,
        top: this.barTop,
        fontSize: Math.min(Math.max(this.barFontSize, 8.5), 14) + "px"
      };
    },
    can_show_menu() {
      return (
        (this.$store.state.app_state == 0 &&
          this.$store.state.page_state != 2) ||
        this.$store.state.app_state != 0
      );
    },
    footer_btn_class() {
      let str = "rounded inline-block px-3 py-0 rounded text-white ";
      if (this.site_config.use_footer_as_links) {
        str += "hover:text-gray-300";
      } else {
        str +=
          "shadow-md bg-footer-btn-color hover:bg-footer-btn-color-hover hover:shadow-lg";
      }
      return str;
    },
    submenu_class() {
      return "submenu " + this.submenu_extra_class;
    },
    get_this() {
      return this;
    }
  },
  methods: {
    get_item_href(item) {
      if ("undefined" == typeof item.type) {
        return (
          "static/content/" +
          this.selected_section +
          "/" +
          this.selected_sub_section +
          "/pdf/" +
          item.filename
        );
      } else {
        return item.filename;
      }
    },
    getCurrentISIContent(section_id) {
      return this.sectionContent("isi").subids[section_id];
    },
    on_section_click(e, section_id) {
      e.preventDefault();
      for (let i = 0; i < this.sections.length; i++) {
        let section = this.sections[i];
        if (section.id == section_id) {
          this.$store.dispatch("set_current_section", section.id);
          this.$store.dispatch("set_popup_state", section.popup_type);
          try {
            this.$ga.event(this.eventTag + "menubar", "click", section.name, 1);
          } catch (err) {}
          break;
        }
      }
    },
    on_footer_content_click(e, section) {
      /*this.$store.dispatch("set_secondary_section", {
        section: "footer",
        sub_section: section
      });

      this.$store.dispatch(
        "set_popup_state",
        this.sections_content["footer"].subids[section].type
      );*/
    },
    on_footer_popup_click(e, link_index) {
      this.$bus.$emit("on-section-anim-ended", {
        id: this.footer_additional_links[link_index].href[0],
        subid: this.footer_additional_links[link_index].href[1]
      });
    },
    on_footer_submenu_popup_click(e, link_index, sublink_index) {
      this.$bus.$emit("on-section-anim-ended", {
        id: this.footer_additional_links[link_index].menu[sublink_index]
          .href[0],
        subid: this.footer_additional_links[link_index].menu[sublink_index]
          .href[1]
      });
    },
    on_footer_link_click(e, link_index) {
      try {
        this.$ga.event(
          this.eventTag + "footerlink",
          "click",
          this.footer_additional_links[i].title,
          1
        );
      } catch (err) {}
    },
    on_footer_menu_click(e, idx) {
      e.stopPropagation();
      this.submenu_extra_class = this.submenu_extra_class == "" ? "active" : "";
    },
    check_submenu(e) {
      console.log(e.target);

      if (this.submenu_extra_class != "") this.submenu_extra_class = "";
    }
  },
  created: function () {
    window.addEventListener("click", this.check_submenu);
    window.addEventListener("blur", this.check_submenu);
  },
  destroyed: function () {
    window.removeEventListener("click", this.check_submenu);
    window.removeEventListener("blur", this.check_submenu);
  }
};
</script>
<style scoped>
.floating-bar {
  margin-top: 0;
  padding: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.floating-bar img {
  height: auto;
  align-self: bottom;
  display: inline-block;
  flex: 0;
  padding: 0 7px;
}
.footer-links {
  height: 100%;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.footer-links li {
  margin: 0;
  min-width: 28%;
  margin: 0;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
  position: relative;
}

.footer-links li .submenu {
  background: #fff;
  padding: 0;
  position: absolute;
  bottom: 30px;
  box-shadow: 1px 2px 2px 1px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  left: 50%;
  min-width: 270px;
  transform: translateX(-50%);
  display: none;
}
.footer-links li .submenu.active {
  display: block;
}
.footer-links li .submenu li {
  text-shadow: none;
  margin: 0;
}
.footer-links li .submenu li a {
  padding: 8px 6px;
  display: block;
  border-bottom: 1px solid #dee;
}
.footer-links li .submenu li a:hover {
  background: #fafafa;
  color: #ff3200;
}
</style>



// WEBPACK FOOTER //
// src/components/FloatingBar.vue